export const translationDictionary = {
    id: 'ID',
    amount: 'Monto',
    authorization: 'Autorización',
    method: 'Método',
    operation_type: 'Tipo de operación',
    transaction_type: 'Tipo de transacción',
    card: 'Tarjeta',
    type: 'Tipo',
    brand: 'Marca',
    address: 'Dirección',
    card_number: 'Número de tarjeta',
    holder_name: 'Nombre del titular',
    expiration_year: 'Año de expiración',
    expiration_month: 'Mes de expiración',
    allows_charges: 'Permite cargos',
    allows_payouts: 'Permite pagos',
    bank_name: 'Nombre del banco',
    bank_code: 'Código del banco',
    bank_account: 'Cuenta de banco',
    bank_trasfer: 'Transferencia',
    store: 'Tienda',
    'card.card_number': 'Número de tarjeta',
    'card.holder_name': 'Nombre del titular',
    'card.expiration_year': 'Año de expiración',
    'card.expiration_month': 'Mes de expiración',
    'card.allows_charges': 'Permite cargos',
    'card.allows_payouts': 'Permite pagos',
    'card.bank_name': 'Nombre del banco',
    'card.bank_code': 'Código del banco',
    'card.type': 'Tipo de tarjeta',
    'card.brand': 'Marca de tarjeta',
    'card.address': 'Dirección de tarjeta',
    'card.address.line1': 'Tarjeta Calle y número',
    'card.address.line2': 'Tarjeta Colonia',
    'card.address.line3': 'Tarjeta Localidad',
    'card.address.state': 'Tarjeta Estado',
    'card.address.city': 'Tarjeta Ciudad',
    'card.address.postal_code': 'Tarjeta Código postal',
    'card.address.country_code': 'Tarjeta Código de país',
    'fee.amount': 'Monto de tarifa',
    'fee.tax': 'Impuesto de tarifa',
    'fee.currency': 'Moneda de tarifa',
    status: 'Estado',
    currency: 'Moneda',
    creation_date: 'Fecha de creación',
    operation_date: 'Fecha de operación',
    description: 'Descripción',
    error_message: 'Mensaje de error',
    order_id: 'ID de orden',
    customer_id: 'ID de cliente',
    payment_method: 'Método de pago',
    agreement: 'Acuerdo',
    bank: 'Banco',
    clabe: 'CLABE',
    name: 'Nombre',
    'payment_method.type': 'Tipo',
    'payment_method.agreement': 'Acuerdo',
    'payment_method.bank': 'Banco',
    'payment_method.clabe': 'Clabe',
    'payment_method.name': 'Nombre',
};

export const translateKey = (key) => {
    return translationDictionary[key] || key;
};
